import { render, staticRenderFns } from "./objetivo.vue?vue&type=template&id=2611644c&"
import script from "./objetivo.vue?vue&type=script&lang=js&"
export * from "./objetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports